import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getLeaseDealsValueRating } from 'site-modules/lease-deals/utils/get-lease-deals-value-rating';
import { useTooltipCollision } from './utils/use-tooltip-collision';
import { getDotsConfig } from './utils/get-dots-config';
import { TooltipMarker } from './tooltip-marker';

import './price-comparison-bar.scss';

export const PriceComparisonBar = ({ effectivePayment, effectivePaymentRatio, effectivePaymentMedian = null }) => {
  const dotsToRender = useMemo(() => {
    const { rating } = getLeaseDealsValueRating(effectivePaymentRatio);
    return getDotsConfig(effectivePayment, effectivePaymentMedian, rating);
  }, [effectivePayment, effectivePaymentRatio, effectivePaymentMedian]);

  const { containerRef, setTooltipRef } = useTooltipCollision(dotsToRender);

  return (
    <div className="pb-3_5">
      <div ref={containerRef} className="price-comparison-bar pos-r">
        <div className="track d-flex justify-content-between rounded-pill">
          <div className="segment green rounded-pill" />
          <div className="segment blue rounded-pill" />
          <div className="segment orange rounded-pill" />
        </div>

        {dotsToRender.map(dot => (
          <TooltipMarker key={dot.id} dot={dot} setRef={setTooltipRef} />
        ))}
      </div>
    </div>
  );
};

PriceComparisonBar.propTypes = {
  effectivePayment: PropTypes.number.isRequired,
  effectivePaymentRatio: PropTypes.number.isRequired,
  effectivePaymentMedian: PropTypes.number,
};
